import { Alert, Link, Stack, Typography } from '@customink/pigment-react';
import { styled } from '@customink/pigment-react/lib/themeCustomink';

import { useEditDesignLink } from '@/hooks/Design';

const AlertList = styled('ul')({
  fontSize: '0.875rem',
  lineHeight: '1.5',
  marginTop: '0.25rem',
  paddingLeft: '1rem',
});

const StyledLink = styled(Link)({
  textDecoration: 'underline',
});

export default function MinimumSleeveQuantity({
  designCid,
  onEnterQuantitiesClick,
}: {
  designCid?: string;
  onEnterQuantitiesClick?: () => void;
}) {
  const handleEditDesign = useEditDesignLink(designCid);
  return (
    <Alert data-testid="minimum-sleeve-quantity-alert" severity="error">
      <Stack direction="column" gap={2}>
        <Typography variant="heading5">
          A change is needed for this order
        </Typography>
        <Stack direction="column" gap={0.5}>
          <Typography variant="uiTextSmall">
            <strong>Sleeve designs require an order minimum of 6.</strong>{' '}
            Please either:
          </Typography>
          <AlertList>
            <li>
              <Typography variant="uiTextSmall">
                <StyledLink
                  button
                  data-testid="increase-quantity-link"
                  onClick={onEnterQuantitiesClick}
                >
                  Increase the order quantity
                </StyledLink>{' '}
                to 6 or more
              </Typography>
            </li>
            <li>
              <Typography variant="uiTextSmall">
                Remove your sleeve design in the{' '}
                <StyledLink
                  button
                  data-testid="remove-sleeve-design-link"
                  onClick={handleEditDesign}
                >
                  Design Lab
                </StyledLink>
              </Typography>
            </li>
          </AlertList>
        </Stack>
      </Stack>
    </Alert>
  );
}
